var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.886 4.13649C20.2375 3.78502 20.2375 3.21517 19.886 2.8637C19.5345 2.51223 18.9647 2.51223 18.6132 2.8637L10.1132 11.3637C9.76174 11.7152 9.76174 12.285 10.1132 12.6365L18.6132 21.1365C18.9647 21.488 19.5345 21.488 19.886 21.1365C20.2375 20.785 20.2375 20.2152 19.886 19.8637L12.0224 12.0001L19.886 4.13649Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.886 4.13649C14.2375 3.78502 14.2375 3.21517 13.886 2.8637C13.5345 2.51223 12.9647 2.51223 12.6132 2.8637L4.11321 11.3637C3.76174 11.7152 3.76174 12.285 4.11321 12.6365L12.6132 21.1365C12.9647 21.488 13.5345 21.488 13.886 21.1365C14.2375 20.785 14.2375 20.2152 13.886 19.8637L6.0224 12.0001L13.886 4.13649Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeft);
export default __webpack_public_path__ + "static/media/double-left.d8b83763942480d0802f8720990fb18f.svg";
export { ForwardRef as ReactComponent };